import axios, { AxiosPromise } from 'axios';

import { IContactInfo } from '../../../@types/model/masterData/contactInfo/contactInfo';
import { IContactInfoUpsert } from '../../../@types/model/masterData/contactInfo/contactInfoUpsert';

export default class ContactInfoHttpService {
    public static getContactInfoData() : AxiosPromise<Array<IContactInfo>> {
        return axios.get(`${API_URL}/v1/ContactInfo/GetAllWeb`);
    }

    public static addOrUpdateContactInfo(upsert : IContactInfoUpsert) : AxiosPromise<IContactInfo> {
        return axios.post(`${API_URL}/v1/ContactInfo/PostContactInfo`, upsert);
    }

    public static deleteContactInfo(contactInfoId : number) : AxiosPromise<IContactInfo> {
        return axios.delete(`${API_URL}/v1/ContactInfo/Delete`, {
            params : { contactInfoId },
        });
    }
}
